module.exports = __webpack_public_path__ + "static/media/mr.b293ed89.svg";